export enum BootstrapStage {
  LOCATE_PLUGIN,
  LOAD_RESOURCES,
  LOAD_THEMES,
  OPEN_OUTPUT_WINDOWS,
  INIT_BIBLES,
  LOAD_PLAYLISTS,
  READY
}

export interface BootstrapperState {
  caption: string,
  currentStage: BootstrapStage,
  failed?: boolean,
  totalStages: number,
  ready: boolean
}
